/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Confirm_Cancel_Schedule_BtnInputs */



/**
* | output |
* | --- |
* | "Keep current tier" |
*
* @param {Sub_Addons_Confirm_Cancel_Schedule_BtnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_confirm_cancel_schedule_btn = /** @type {((inputs?: Sub_Addons_Confirm_Cancel_Schedule_BtnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Confirm_Cancel_Schedule_BtnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuelle Stufe beibehalten")
	return /** @type {LocalizedString} */ ("Keep current tier")
});